import { render, staticRenderFns } from "./S60.vue?vue&type=template&id=16c20c1c&scoped=true"
import script from "./S60.vue?vue&type=script&lang=js"
export * from "./S60.vue?vue&type=script&lang=js"
import style0 from "./S60.vue?vue&type=style&index=0&id=16c20c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c20c1c",
  null
  
)

export default component.exports